(function () {
  if (window.mtIniciado) return;
  window.mtIniciado = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, [data-mt-contador]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reducido) {
      els.forEach(function (el) { el.classList.add('mt-visible'); if (el.hasAttribute('data-mt-contador')) contar(el, true); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        if (e.target.hasAttribute('data-mt-contador')) contar(e.target, false);
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function contar(el, inmediato) {
    var fin = parseInt(el.getAttribute('data-mt-contador'), 10) || 0;
    if (inmediato) { el.textContent = fin; return; }
    var dur = 1600, t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      var principal = g.querySelector('[data-mt-principal]');
      if (!principal) return;
      g.querySelectorAll('[data-mt-mini]').forEach(function (b) {
        b.addEventListener('click', function () {
          principal.src = b.getAttribute('data-src');
          principal.alt = b.getAttribute('data-alt') || '';
          g.querySelectorAll('[data-mt-mini]').forEach(function (x) { x.classList.remove('is-activa'); });
          b.classList.add('is-activa');
        });
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-mt-cantidad]').forEach(function (c) {
      var input = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-paso'), 10);
          input.value = Math.max(1, Math.min(10, v));
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-compra]').forEach(function (box) {
      var datos = box.querySelector('[data-mt-variantes]');
      var selects = box.querySelectorAll('[data-mt-opcion]');
      if (!datos || !selects.length) return;
      var variantes = JSON.parse(datos.textContent);
      var idInput = box.querySelector('input[name="id"]');
      var boton = box.querySelector('[data-mt-boton]');
      var precio = box.querySelectorAll('[data-mt-precio]');
      var antes = box.querySelectorAll('[data-mt-antes]');
      var fmt = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-CO'); };
      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) return;
        idInput.value = v.id;
        precio.forEach(function (p) { p.textContent = fmt(v.price); });
        antes.forEach(function (a) { a.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; });
        boton.disabled = !v.available;
        boton.querySelector('[data-mt-boton-texto]').textContent = v.available ? boton.getAttribute('data-texto') : boton.getAttribute('data-agotado');
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }

  function initBarraFija() {
    // La barra de compra aparece siempre que no haya otro botón de compra a la vista
    // (el de la apertura o el del formulario), para no tapar la primera pantalla ni repetir botones.
    var barra = document.querySelector('[data-mt-fija]');
    var objetivo = document.querySelector('[data-mt-boton]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    var botones = Array.prototype.slice.call(document.querySelectorAll('.mt-hero .mt-btn, [data-mt-boton]'));
    var visibles = new Set();
    var listo = false;
    function refrescar() {
      if (!listo) return;
      var mostrar = visibles.size === 0;
      barra.classList.toggle('is-visible', mostrar);
      document.body.classList.toggle('mt-fija-activa', mostrar && window.innerWidth <= 990);
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) visibles.add(e.target); else visibles.delete(e.target); });
      listo = true;
      refrescar();
    });
    botones.forEach(function (b) { io.observe(b); });
    // En móvil la burbuja de WhatsApp se esconde mientras está en pantalla el botón de la apertura o un botón
    // "¿Prefieres pedir por WhatsApp?" (fuera del carrito), para no taparlos ni repetir el mismo acceso.
    var tapables = Array.prototype.slice.call(document.querySelectorAll('.mt-hero .mt-btn, .mt-section [data-mt-wa-pedir]'));
    var aLaVista = new Set();
    if (tapables.length) {
      var ioWa = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) aLaVista.add(e.target); else aLaVista.delete(e.target); });
        document.body.classList.toggle('mt-hero-boton-visible', aLaVista.size > 0);
      });
      tapables.forEach(function (b) { ioWa.observe(b); });
    }
    window.addEventListener('scroll', refrescar, { passive: true });
    var btn = barra.querySelector('a, button');
    if (btn) btn.addEventListener('click', function (ev) {
      if (irAPagar(ev)) return;
      ev.preventDefault();
      objetivo.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'center' });
    });
  }

  /* Sirena: se crea un audio WAV en el navegador (sin descargar archivos) y se reproduce
     con un <audio> normal, que en iPhone suena aunque el celular esté en modo silencio. */
  var urlSirena = null;
  function crearSirenaWav() {
    if (urlSirena) return urlSirena;
    var tasa = 22050, seg = 3.5, n = Math.floor(tasa * seg), vol = 0.09;
    var buf = new ArrayBuffer(44 + n * 2), v = new DataView(buf);
    function txt(o, t) { for (var k = 0; k < t.length; k++) v.setUint8(o + k, t.charCodeAt(k)); }
    txt(0, 'RIFF'); v.setUint32(4, 36 + n * 2, true); txt(8, 'WAVE'); txt(12, 'fmt ');
    v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
    v.setUint32(24, tasa, true); v.setUint32(28, tasa * 2, true); v.setUint16(32, 2, true); v.setUint16(34, 16, true);
    txt(36, 'data'); v.setUint32(40, n * 2, true);
    // Onda cuadrada de 1500 Hz que sube y baja ±650 Hz, 3,2 veces por segundo (como antes)
    var fase = 0;
    for (var k = 0; k < n; k++) {
      var t = k / tasa, x = (t * 3.2) % 1, tri = x < 0.5 ? 4 * x - 1 : 3 - 4 * x;
      fase += (1500 + 650 * tri) / tasa; fase -= Math.floor(fase);
      var env = Math.min(1, t / 0.05, (seg - t) / 0.08);
      v.setInt16(44 + k * 2, (fase < 0.5 ? 1 : -1) * vol * env * 32767, true);
    }
    urlSirena = URL.createObjectURL(new Blob([buf], { type: 'audio/wav' }));
    return urlSirena;
  }
  function initSirena() {
    document.querySelectorAll('[data-mt-sirena]').forEach(function (btn) {
      if (btn.dataset.mtSirenaLista) return; btn.dataset.mtSirenaLista = '1';
      var audio = null, temporizador = null;
      var etiqueta = btn.querySelector('strong');
      var seccion = btn.closest('.mt-cifra');
      function marcar(sonando) {
        btn.classList.toggle('is-sonando', sonando); if (seccion) seccion.classList.toggle('is-sonando', sonando);
        btn.setAttribute('aria-pressed', sonando ? 'true' : 'false');
        if (etiqueta) etiqueta.textContent = sonando ? (etiqueta.getAttribute('data-texto-activo') || etiqueta.getAttribute('data-texto')) : etiqueta.getAttribute('data-texto');
      }
      function parar() {
        if (temporizador) { clearTimeout(temporizador); temporizador = null; }
        if (audio) { audio.pause(); audio.currentTime = 0; }
        marcar(false);
      }
      function sonar() {
        if (!audio) { audio = new Audio(crearSirenaWav()); audio.addEventListener('ended', parar); }
        audio.currentTime = 0;
        var p = audio.play(); if (p && p.catch) p.catch(function () { parar(); });
        marcar(true);
        temporizador = setTimeout(parar, 3700);
      }
      btn.addEventListener('click', function () { if (btn.classList.contains('is-sonando')) parar(); else sonar(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden && btn.classList.contains('is-sonando')) parar(); });
    });
  }

  function initCarruseles() {
    document.querySelectorAll('.mt-grid--carrusel').forEach(function (pista) {
      var items = pista.children;
      if (items.length < 2) return;
      var puntos = document.createElement('div');
      puntos.className = 'mt-carrusel__puntos'; puntos.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < items.length; i++) puntos.appendChild(document.createElement('span'));
      pista.parentNode.insertBefore(puntos, pista.nextSibling);
      function marcar() {
        var centro = pista.scrollLeft + pista.clientWidth / 2, mejor = 0, dist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].offsetLeft + items[i].offsetWidth / 2 - centro);
          if (d < dist) { dist = d; mejor = i; }
        }
        for (var j = 0; j < puntos.children.length; j++) puntos.children[j].classList.toggle('is-activo', j === mejor);
      }
      pista.addEventListener('scroll', marcar, { passive: true });
      marcar();
    });
  }

  // Envía el formulario de compra (con su variante y cantidad) para ir directo al pago.
  // Si no hay formulario o el producto está agotado, se queda el comportamiento de bajar a la compra.
  function irAPagar(ev, cantidad) {
    var boton = document.querySelector('[data-mt-boton]');
    if (!boton || boton.disabled || !boton.form) return false;
    ev.preventDefault();
    if (cantidad) {
      var campo = boton.form.querySelector('input[name="quantity"]');
      if (!campo) { campo = document.createElement('input'); campo.type = 'hidden'; campo.name = 'quantity'; boton.form.appendChild(campo); }
      campo.value = cantidad;
    }
    enviarPedido(boton.form);
    return true;
  }

  // Quita del carrito las líneas de este mismo producto (así no se acumulan de visitas o clics
  // anteriores) y deja los demás productos. Si no se sabe qué producto es, vacía la bolsa como antes.
  function quitarMismoProducto(form, raiz) {
    var campo = form.querySelector('[data-mt-producto]');
    var id = campo ? Number(campo.value) : 0;
    if (!id) return fetch(raiz + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }).catch(function () {});
    return fetch(raiz + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (bolsa) {
        var cambios = {}, hay = false;
        (bolsa.items || []).forEach(function (it) {
          if (it.product_id === id) { cambios[it.key] = 0; hay = true; }
        });
        if (!hay) return;
        return fetch(raiz + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: cambios }) });
      })
      .catch(function () {});
  }

  // Quita este producto de la bolsa, agrega la cantidad elegida y abre el carrito lateral.
  // Los demás productos que ya estaban en la bolsa se quedan.
  // Si el carrito lateral no está disponible, manda directo a pagar como antes.
  function enviarPedido(form) {
    if (form.dataset.mtEnviando) return;
    form.dataset.mtEnviando = '1';
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    setTimeout(function () { delete form.dataset.mtEnviando; }, 8000);
    var cajon = document.querySelector('cart-drawer');
    var directo = function () { HTMLFormElement.prototype.submit.call(form); };
    var vaciar = quitarMismoProducto(form, raiz);
    if (!cajon || typeof cajon.renderContents !== 'function' || typeof cajon.getSectionsToRender !== 'function') {
      vaciar.then(directo);
      return;
    }
    var datos = new FormData(form);
    datos.delete('return_to');
    datos.append('sections', cajon.getSectionsToRender().map(function (x) { return x.id; }).join(','));
    datos.append('sections_url', window.location.pathname);
    vaciar
      .then(function () {
        return fetch(raiz + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: datos });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || res.status || !res.sections) { directo(); return; }
        // Si la bolsa estaba vacía, el cajón está marcado 'is-empty' y escondería el producto
        cajon.classList.remove('is-empty');
        reservaReiniciar();
        cajon.renderContents(res);
        delete form.dataset.mtEnviando;
      })
      .catch(directo);
  }

  // Al volver a la página desde el pago (botón atrás o cambiando de pestaña), el navegador
  // la restaura tal cual quedó: se libera el envío para que los botones vuelvan a funcionar.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[data-mt-enviando]').forEach(function (f) { delete f.dataset.mtEnviando; });
  });

  // Botón del carrito vacío: agrega el candado ahí mismo si la página tiene su formulario de compra;
  // si no (Contacto, Envíos, la página de otro producto...), el enlace lleva a la página del candado.
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-mt-agregar]');
    if (!a) return;
    var boton = document.querySelector('[data-mt-boton]');
    var campo = boton && boton.form && boton.form.querySelector('[data-mt-producto]');
    if (a.dataset.mtAgregar && campo && campo.value !== a.dataset.mtAgregar) return;
    irAPagar(ev, 1);
  });

  // "¿Prefieres pedir por WhatsApp?": al tocar, pone en el mensaje la cantidad elegida y su total.
  // En el carrito el enlace ya viene listo desde el servidor con lo que hay en la bolsa.
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-mt-wa-pedir]');
    if (!a || a.dataset.contexto === 'carrito') return;
    var campo = null, n = 1;
    if (a.dataset.contexto === 'hero') campo = document.querySelector('[data-mt-cantidad-hero]');
    else { var sec = a.closest('.mt-section'); campo = sec && sec.querySelector('input[name="quantity"]'); }
    if (campo) n = Math.max(1, Math.min(10, parseInt(campo.value, 10) || 1));
    var precio = parseInt(a.dataset.precio, 10) || 0;
    if (!precio || !a.dataset.numero || !a.dataset.mensaje) return;
    var total = '$' + Math.round(precio * n / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    a.href = 'https://wa.me/' + a.dataset.numero + '?text=' + encodeURIComponent(a.dataset.mensaje.replace('[cantidad]', n).replace('[total]', total));
  });

  function initFormularioCompra() {
    var boton = document.querySelector('[data-mt-boton]');
    if (!boton || !boton.form) return;
    boton.form.addEventListener('submit', function (ev) { ev.preventDefault(); enviarPedido(boton.form); });
  }

  function initSlides() {
    // Cambia de foto cada X segundos, en ciclo. Se pausa si la pestaña no está a la vista.
    document.querySelectorAll('[data-mt-slides]').forEach(function (caja) {
      // La primera foto del recuadro entra al ciclo junto con las marcadas como data-mt-slide
      var primera = caja.querySelector('[data-mt-principal]');
      if (primera) { primera.setAttribute('data-mt-slide', ''); primera.classList.add('is-activa'); }
      var fotos = caja.querySelectorAll('[data-mt-slide]');
      if (fotos.length < 2) return;
      var ms = (parseFloat(caja.getAttribute('data-intervalo')) || 3) * 1000;
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        fotos[i].classList.remove('is-activa');
        i = (i + 1) % fotos.length;
        fotos[i].classList.add('is-activa');
      }, ms);
    });
  }

  function initAnclas() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        // Los botones de "Pedir" no bajan a la sección de compra: envían el pedido directo al pago
        if (id === '#comprar') {
          var c = null;
          if (a.hasAttribute('data-mt-boton-hero')) { var h = document.querySelector('[data-mt-cantidad-hero]'); if (h) c = Math.max(1, Math.min(10, parseInt(h.value, 10) || 1)); }
          if (irAPagar(ev, c)) return;
        }
        var t = document.querySelector(id);
        if (!t) return;
        ev.preventDefault();
        t.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initBarras() {
    document.querySelectorAll('[data-mt-secuencia]').forEach(function (grupo) {
      if (grupo.dataset.mtListo) return;
      grupo.dataset.mtListo = '1';
      var items = grupo.querySelectorAll('.mt-barra-item');
      var dur = (parseFloat(grupo.getAttribute('data-duracion')) || 1.4) * 1000;
      var pausa = (parseFloat(grupo.getAttribute('data-pausa')) || 0) * 1000;

      function numero(el, fin, ms) {
        var t0 = null;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / ms, 1);
          var e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          el.textContent = Math.round(fin * e);
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }

      function llenar(i) {
        if (i >= items.length) return;
        var item = items[i];
        var barra = item.querySelector('[data-mt-relleno]');
        var valor = item.querySelector('[data-mt-valor]');
        item.classList.add('is-activa');
        barra.classList.add('is-llenando');
        barra.style.width = (parseFloat(barra.getAttribute('data-mt-relleno')) || 0) + '%';
        if (valor) numero(valor, parseInt(valor.getAttribute('data-mt-valor'), 10) || 0, dur);
        setTimeout(function () {
          barra.classList.remove('is-llenando');
          if (i < items.length - 1) item.classList.remove('is-activa');
          llenar(i + 1);
        }, dur + pausa);
      }

      // Todas las barras se llenan a la vez; la destacada (o la última) queda encendida al final
      function llenarTodas() {
        items.forEach(function (item, i) {
          var barra = item.querySelector('[data-mt-relleno]');
          var valor = item.querySelector('[data-mt-valor]');
          item.classList.add('is-activa');
          barra.classList.add('is-llenando');
          barra.style.width = (parseFloat(barra.getAttribute('data-mt-relleno')) || 0) + '%';
          if (valor) numero(valor, parseInt(valor.getAttribute('data-mt-valor'), 10) || 0, dur);
          setTimeout(function () {
            barra.classList.remove('is-llenando');
            if (i < items.length - 1) item.classList.remove('is-activa');
          }, dur + pausa);
        });
      }

      // Estado inicial: barras vacías y números en 0
      items.forEach(function (it) {
        var v = it.querySelector('[data-mt-valor]');
        if (v && !reducido) v.textContent = '0';
      });

      if (reducido || !('IntersectionObserver' in window)) {
        items.forEach(function (it) {
          var b = it.querySelector('[data-mt-relleno]');
          var v = it.querySelector('[data-mt-valor]');
          b.style.width = b.getAttribute('data-mt-relleno') + '%';
          if (v) v.textContent = v.getAttribute('data-mt-valor');
        });
        return;
      }
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        if (grupo.getAttribute('data-modo') === 'simultaneo') llenarTodas(); else llenar(0);
      }, { threshold: 0.35 });
      io.observe(grupo);
    });
  }

  function initLinea() {
    document.querySelectorAll('[data-mt-linea]').forEach(function (l) {
      if (reducido || !('IntersectionObserver' in window)) { l.classList.add('is-activa'); return; }
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        l.classList.add('is-activa');
      }, { threshold: 0.3 });
      io.observe(l);
    });
  }

  /* Fecha estimada de entrega: días hábiles de Colombia (sin domingos ni festivos) */
  function festivosCO(anio) {
    var f = {};
    function dia(m, d) { return Date.UTC(anio, m - 1, d); }
    function marcar(t) { f[new Date(t).toISOString().slice(0, 10)] = true; }
    function lunes(t) { var w = new Date(t).getUTCDay(); return w === 1 ? t : t + ((8 - w) % 7) * 864e5; }
    [[1,1],[5,1],[7,20],[8,7],[12,8],[12,25]].forEach(function (x) { marcar(dia(x[0], x[1])); });
    [[1,6],[3,19],[6,29],[8,15],[10,12],[11,1],[11,11]].forEach(function (x) { marcar(lunes(dia(x[0], x[1]))); });
    // Pascua (algoritmo de Butcher) y festivos que dependen de ella
    var a = anio % 19, b = Math.floor(anio / 100), c = anio % 100, d = Math.floor(b / 4), e = b % 4,
        g = Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        mes = Math.floor((h + l - 7 * m + 114) / 31), dd = ((h + l - 7 * m + 114) % 31) + 1, pascua = dia(mes, dd);
    marcar(pascua - 3 * 864e5); marcar(pascua - 2 * 864e5);
    [43, 64, 71].forEach(function (n) { marcar(pascua + n * 864e5); });
    return f;
  }
  function initEntrega() {
    var els = document.querySelectorAll('[data-mt-entrega]');
    if (!els.length) return;
    var cache = {};
    function esHabil(t, sabado) {
      var fch = new Date(t), w = fch.getUTCDay(), anio = fch.getUTCFullYear();
      if (w === 0 || (w === 6 && !sabado)) return false;
      cache[anio] = cache[anio] || festivosCO(anio);
      return !cache[anio][fch.toISOString().slice(0, 10)];
    }
    function sumar(t, n, sabado) { while (n > 0) { t += 864e5; if (esHabil(t, sabado)) n--; } return t; }
    function formato(t) { var x = new Date(t); return ('0' + x.getUTCDate()).slice(-2) + '/' + ('0' + (x.getUTCMonth() + 1)).slice(-2) + '/' + x.getUTCFullYear(); }
    // "Ahora" en Colombia (UTC-5, sin horario de verano), leído con getUTC*
    var ahora = new Date(Date.now() - 5 * 36e5);
    var hoy = Date.UTC(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate());
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.mtHecho) return; el.dataset.mtHecho = '1';
      var min = parseInt(el.dataset.min, 10) || 3, max = Math.max(parseInt(el.dataset.max, 10) || 5, min);
      var corte = parseInt(el.dataset.corte, 10), sabado = el.dataset.sabado === 'true';
      // Día en que sale el pedido: hoy si es hábil y antes del corte; si no, el siguiente hábil
      var salida = (esHabil(hoy, sabado) && ahora.getUTCHours() < corte) ? hoy : sumar(hoy, 1, sabado);
      var desde = formato(sumar(salida, min, sabado)), hasta = formato(sumar(salida, max, sabado));
      var span = el.querySelector('[data-mt-entrega-texto]'), plantilla = el.dataset.texto || 'Recíbelo entre el [desde] y el [hasta]';
      span.textContent = '';
      // Cada fecha va pegada a las 2 palabras anteriores ("y el 19/10/2026") para que, si la línea se parte, no quede sola
      var partes = plantilla.split(/(\[desde\]|\[hasta\])/);
      partes.forEach(function (parte, n) {
        if (parte === '[desde]' || parte === '[hasta]') return;
        var siguiente = partes[n + 1], previa = '';
        if (siguiente === '[desde]' || siguiente === '[hasta]') {
          var m = parte.match(/(\S+\s+)?\S+\s*$/);
          if (m) { previa = m[0]; parte = parte.slice(0, m.index); }
        }
        if (parte) span.appendChild(document.createTextNode(parte));
        if (siguiente === '[desde]' || siguiente === '[hasta]') {
          var grupo = document.createElement('span'); grupo.className = 'mt-entrega__fecha';
          grupo.appendChild(document.createTextNode(previa));
          var b = document.createElement('strong'); b.textContent = siguiente === '[desde]' ? desde : hasta;
          grupo.appendChild(b); span.appendChild(grupo);
        }
      });
    });
  }

  /* "Tú decides": cambia entre con alarma y en silencio */
  function initModoAlarma() {
    document.querySelectorAll('[data-mt-modo]').forEach(function (caja) {
      if (caja.dataset.mtListo) return; caja.dataset.mtListo = '1';
      caja.querySelectorAll('[data-modo]').forEach(function (b) {
        b.addEventListener('click', function () {
          caja.dataset.estado = b.dataset.modo;
          caja.querySelectorAll('[data-modo]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Reserva con cronómetro: el carrito se guarda X minutos y al llegar a 0 se vacía solo.
     Se reinicia cada vez que se agrega algo. La hora límite se guarda en el navegador,
     así el cronómetro sigue corriendo aunque la persona cambie de página. */
  var RESERVA_CLAVE = 'mtReservaHasta', reservaReloj = null, reservaUltima = null, reservaVaciando = false, reservaMemoria = 0, reservaEscuchando = false;
  function reservaCajon() { var c = document.querySelector('cart-drawer'); return c && c.hasAttribute('data-mt-reserva-min') ? c : null; }
  function reservaLeer() {
    var v = 0;
    try { v = parseInt(window.localStorage.getItem(RESERVA_CLAVE), 10) || 0; } catch (e) {}
    return v || reservaMemoria;
  }
  function reservaGuardar(t) {
    reservaMemoria = t;
    try { if (t) window.localStorage.setItem(RESERVA_CLAVE, String(t)); else window.localStorage.removeItem(RESERVA_CLAVE); } catch (e) {}
  }
  function reservaCuenta(c) {
    if (c.classList.contains('is-empty')) return 0;
    var n = c.querySelector('.mt-carrito__cuenta');
    return n ? (parseInt(n.textContent, 10) || 0) : 0;
  }
  function reservaPintar(c, resto) {
    var caja = c.querySelector('[data-mt-reserva]'), el = caja && caja.querySelector('[data-mt-reserva-tiempo]');
    if (!el) return;
    var seg = Math.max(0, Math.ceil(resto / 1000));
    var txt = ('0' + Math.floor(seg / 60)).slice(-2) + ':' + ('0' + (seg % 60)).slice(-2);
    // Se cambia el texto del nodo existente (no se reemplaza) para no despertar al observador del carrito cada segundo
    if (el.firstChild && el.firstChild.nodeType === 3) { if (el.firstChild.data !== txt) el.firstChild.data = txt; }
    else el.textContent = txt;
    caja.classList.toggle('is-urgente', seg <= 60);
  }
  function reservaParar() { if (reservaReloj) { clearInterval(reservaReloj); reservaReloj = null; } }
  function reservaReiniciar() {
    var c = reservaCajon();
    if (!c) return;
    reservaGuardar(Date.now() + (parseFloat(c.getAttribute('data-mt-reserva-min')) || 5) * 60000);
    c.removeAttribute('data-mt-vencido');
  }
  function reservaVencer(c) {
    if (reservaVaciando) return;
    // Solo se vacía con esta página a la vista: así no se le borra el pedido a alguien que está pagando en otra pestaña.
    // Si está oculta, la hora límite queda vencida y se vacía en cuanto la persona vuelva.
    if (document.hidden) return;
    reservaVaciando = true; reservaParar(); reservaGuardar(0);
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var leer = function (html, sel) { return html ? new DOMParser().parseFromString(html, 'text/html').querySelector(sel) : null; };
    fetch(raiz + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        // Si Shopify no devuelve el carrito ya redibujado, se pide aparte: así nunca queda a la vista un producto que ya no está
        if (res && res.sections && res.sections['cart-drawer']) return res.sections;
        return fetch(raiz + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
      })
      .then(function (sec) {
        if (!sec) return;
        var nuevo = leer(sec['cart-drawer'], '.drawer__inner'), actual = c.querySelector('.drawer__inner');
        c.setAttribute('data-mt-vencido', '1');
        c.classList.add('is-empty');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
        var globo = document.getElementById('cart-icon-bubble'), nuevoGlobo = leer(sec['cart-icon-bubble'], '.shopify-section');
        if (globo && nuevoGlobo) globo.innerHTML = nuevoGlobo.innerHTML;
      })
      .catch(function () {})
      .then(function () { reservaVaciando = false; reservaUltima = 0; });
  }
  function reservaRevisar() {
    var c = reservaCajon();
    if (!c || reservaVaciando) return;
    var n = reservaCuenta(c);
    if (n === 0) { reservaParar(); reservaGuardar(0); reservaUltima = 0; return; }
    c.removeAttribute('data-mt-vencido');
    var hasta = reservaLeer();
    // Empieza si no había cronómetro, y se reinicia si ahora hay más unidades que la última vez
    if (!hasta || (reservaUltima !== null && n > reservaUltima)) { reservaReiniciar(); hasta = reservaLeer(); }
    reservaUltima = n;
    var resto = hasta - Date.now();
    if (resto <= 0) { reservaPintar(c, 0); reservaVencer(c); return; }
    reservaPintar(c, resto);
    if (!reservaReloj) reservaReloj = setInterval(reservaRevisar, 1000);
  }
  function initReserva() {
    if (!reservaEscuchando) {
      reservaEscuchando = true;
      // Al volver a la pestaña o a la página (los cronómetros se frenan en segundo plano), se pone al día
      document.addEventListener('visibilitychange', function () { if (!document.hidden) reservaRevisar(); });
      window.addEventListener('pageshow', reservaRevisar);
      window.addEventListener('storage', function (ev) { if (ev.key === RESERVA_CLAVE) reservaRevisar(); });
    }
    reservaRevisar();
  }

  function init() {
    initReveal(); initBarras(); initLinea(); initGaleria(); initCantidad(); initVariantes(); initBarraFija(); initAnclas(); initSirena(); initCarruseles(); initFormularioCompra(); initSlides(); initEntrega(); initModoAlarma(); initReserva();
    // El carrito lateral se vuelve a dibujar al cambiar cantidades: recalcula la fecha de entrega y pone al día la reserva
    var cajon = document.querySelector('cart-drawer');
    if (cajon && !cajon.dataset.mtObservado && 'MutationObserver' in window) {
      cajon.dataset.mtObservado = '1';
      new MutationObserver(function () { initEntrega(); reservaRevisar(); }).observe(cajon, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.mtIniciado = false; init(); });
})();
